import React from 'react'

export default ({
                    field,
                    form,
                    form: {touched, errors},
                    data,
                    onAddValue,
                    onRemoveValue,
                    arrayHelpers,
                    ...props
                }) => {


    return <div className={`checkbox checkbox--vc ${props.className}`} data-testid="checkbox">
        <input
            id={`checkbox-${data.id}`}
            type='checkbox'
            value={data.value}
            {...field}
            checked={form.values.consents.includes(data.value)}
            onChange={e => {
                if (e.target.checked) arrayHelpers.push(data.value)
                else {
                    const idx = form.values.consents.indexOf(data.value)
                    arrayHelpers.remove(idx)
                }
            }}
        />
        <label
            htmlFor={`checkbox-${data.id}`}
            className={data.label && 'checkbox--vc--labeled'}
        >
            {data.label && Array.isArray(data.label) ?
                <div>{data.label.map((val, i) => <span key={i}>{val}</span>)}</div> : <div>{data.label}</div>}
        </label>
    </div>

}
